import * as React from "react";
import { Dialog } from "@base-ui/react/dialog";
import { cn } from "@/lib/utils";

const Sheet = Dialog.Root;
const SheetTitle = Dialog.Title;

function SheetContent({
  className,
  children,
  side = "right",
}: React.ComponentProps<typeof Dialog.Popup> & { side?: "left" | "right" }) {
  return (
    <Dialog.Portal>
      <Dialog.Backdrop className="fixed inset-0 z-40 bg-black/70 transition-opacity duration-150 data-ending-style:opacity-0 data-starting-style:opacity-0 motion-reduce:transition-none" />
      <Dialog.Viewport
        className={cn(
          "fixed inset-y-0 z-50 flex max-w-[85vw] outline-hidden",
          side === "left" ? "left-0" : "right-0",
        )}
      >
        <Dialog.Popup
          className={cn(
            "flex w-[260px] max-w-[85vw] flex-1 flex-col border-line bg-canvas shadow-panel outline-hidden transition-transform duration-200 ease-out motion-reduce:transform-none motion-reduce:transition-none",
            side === "left"
              ? "border-r data-ending-style:-translate-x-full data-starting-style:-translate-x-full"
              : "border-l data-ending-style:translate-x-full data-starting-style:translate-x-full",
            className,
          )}
        >
          {children}
        </Dialog.Popup>
      </Dialog.Viewport>
    </Dialog.Portal>
  );
}

function SheetClose({ children }: { children: React.ReactElement }) {
  return <Dialog.Close render={children} />;
}

export { Sheet, SheetClose, SheetContent, SheetTitle };
